import { useEffect, useState } from "react"

export interface RemoteData<T> {
  data: T | null
  loading: boolean
  error: boolean
}

export function useRemoteData<T>(load: () => Promise<T>): RemoteData<T> {
  const [state, setState] = useState<RemoteData<T>>({
    data: null,
    loading: true,
    error: false,
  })
  useEffect(() => {
    let active = true
    setState({ data: null, loading: true, error: false })
    void load().then(
      (data) => {
        if (active) setState({ data, loading: false, error: false })
      },
      () => {
        if (active) setState({ data: null, loading: false, error: true })
      }
    )
    return () => {
      active = false
    }
  }, [load])
  return state
}
